import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../../store/hooks';
import NtxTable from '../../../../components/DataTable/NtxTable';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

interface props {
  setID: React.Dispatch<React.SetStateAction<string>>; // For Update
}

const ScanElementList: React.FC<props> = props => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const { ScanElementList2: data } = useAppSelector(state => state.FleetScan);

  const columns = [
    { title: t('#'), key: 'no' },
    { title: t('Item'), key: 'Item' },
    { title: t('Descriptions'), key: 'Descriptions' },
    { title: t('Priority'), key: 'Priority' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  // const tableData = data.scanningElements
  const tableData = data
    ?.slice()
    ?.sort((a, b) => a.sort - b.sort)
    ?.map((item, index) => {
      let rowClass;

      return {
        no: ++index,
        Item: i18n.language === 'en' ? item.name : item.name2,
        Descriptions: i18n.language === 'en' ? item.description : item.description2,
        Priority: item.priority,

        action: (
          <>
            <button
              hidden={!HasPermission('FleetEditInspectionItems')}
              type='button'
              className='btn btn-outline-theme'
              data-bs-toggle='modal'
              data-bs-target='#EditElementModal'
              onClick={() => props.setID(item.id)}
            >
              <i className='far fa-lg fa-fw  fa-edit'></i>
            </button>
          </>
        ),

        rowClass // استخدم rowClass هنا
      };
    });

  return (
    <>
      <NtxTable
        data={tableData || []}
        columns={columns}
        dataPerPage={10}
        theadClass=''
        tableClass='table table-striped table-bordered table-hover '
        enableSearch
        showRecordsSelector
      />
    </>
  );
};

export default ScanElementList;
